module.exports = __webpack_public_path__ + "img/indexw.78901c7d.png";